import React, {useEffect, useState} from 'react';
import {Typography, Select} from 'antd';
import {Block} from './block';
import {isUndefined} from 'lodash';
import classnames from 'classnames';

export function TagBlock({className, value, placeholder, hiddenValue, onCancel, onSave, onValue, delegatedEditMode}) {
    const [editMode, setEditMode] = useState();
    const [editedTag, setEditedTag] = useState();
    const classes = classnames('tagBlock', className);

    useEffect(() => {
        if (!isUndefined(delegatedEditMode)) {
            setEditMode(delegatedEditMode);
        }
    }, [delegatedEditMode]);

    function handleChange(value) {
        let tagArray = value.includes(',') ? value.split(',') : value;
        setEditedTag(tagArray);
        onValue && onValue(tagArray);
    }

    const handleSave = () => {
        setEditMode(false);
        onSave && onSave(editedTag);
    };

    const handleCancel = () => {
        setEditMode(false);
        setEditedTag(value);
        onCancel && onCancel();
    };

    function onEdit() {
        if (!delegatedEditMode) {
            setEditMode(true);
        }
    }

    return (
        <Block name="operation tags" className={classes} onEdit={onEdit} onCancel={handleCancel} onSave={handleSave} delegatedEditMode={delegatedEditMode}>
            {!editMode && value && !hiddenValue && <Typography.Text className="textValue">{value}</Typography.Text>}
            {editMode && (
                <div>
                    <Typography.Text muted>{placeholder}</Typography.Text>
                    <Select mode="tags" style={{width: '100%'}} value={editedTag} placeholder="Add tags..." onChange={handleChange} />
                </div>
            )}
        </Block>
    );
}
